import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarregamentoService {
  private readonly carregandoSubject = new BehaviorSubject<boolean>(false);
  carregando$ = this.carregandoSubject.asObservable();

  Ativar(): void {
    this.carregandoSubject.next(true);
  }

  Desativar(): void {
    this.carregandoSubject.next(false);
  }
}
